
import request from '@/utils/request';
import Vue from 'vue';
//获取列表 
export function countryQuery (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/country/query`,
      data:params
    });
  }
//创建
export function countryCreate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/country/create`,
      data:params
    });
  }
//上移
export function countryMoveUp (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/country/moveUp/${params}`
    });
  }
//下移
export function countryMoveDown (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/country/moveDown/${params}`
    });
  }
// 修改
export function countryUpdate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/country/update`,
      data:params
    });
  }
// 删除 
export function deletecountry (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/country/deleteCountry/${params}`
    });
  }
  //创建放假日历  
  export function countryCalendarCreate (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/countryCalendar/create`,
      data:params
    });
  }
  //删除放假日历 {}
  export function countryCalendarDelete (params) {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/countryCalendar/delete/${params}`
    });
  }
  //查询所有的国家 
  export function countryGetAll () {
    return request({
      method: 'post',
      url: `${Vue.prototype.$conf.visaService}/country/getAll`
    });
  }